import { Environment } from './environment.schema';

export const environment = {
  production: true,
  address: 'https://api.dashboard.behamics.com/api',
  statistics: 'https://statistics.behamics.com',
  bugsProject: 'https://bugs.behamics.com',
  emailserver: 'https://testemailserver.behamics.com',
  modelautomation: 'https://automation.behamics.com',
  autoscript: 'http://autoscript.behamics.com',
  seo: 'https://seo1.behamics.com',
  wcag: 'https://wcag.behamics.com',
  ads: 'https://ads.behamics.com',
  golive: 'https://golive.behamics.com',
} as const satisfies Environment;
